import { FC } from 'react';

import { Image, ImageProps } from '@bonusly/design-system';

const isVideoFile = (src?: string) => {
	if (!src) return false;
	try {
		const url = new URL(src);
		return url.pathname.endsWith('.mp4');
	} catch {
		// Fallback for relative URLs or invalid URLs
		return /\.mp4($|\?)/.test(src);
	}
};

export const ImageOrVideo: FC<ImageProps> = ({ alt, src, ...rest }) => {
	return (
		<Image
			alt={alt}
			src={src}
			{...(isVideoFile(src) && {
				as: 'video', // <video element with chakraUI props
				autoPlay: true,
				loop: true,
				muted: true,
				playsInline: true,
				role: 'application',
				title: alt,
				children: <track kind="captions" srcLang="en" label="english_captions" />,
			})}
			{...rest}
		/>
	);
};
